import { Trip } from "../../DataStructures/Trip/Trip";
import { MapControls } from "../MapControls/MapConrols";
import { reject } from "q";
import { MapquestService } from "../../services/map-quest/mapquest.service";
import { LatLng } from "./LatLng";
import { windowToggle } from "rxjs/operators";
import { DirectionOptions } from "../../DataStructures/DirectionOptions/DirectionOptions";
import { SettingValues } from "../../admin-dashboard/settings/SettingValues";
import { Area } from "../../DataStructures/Area/Area";

export class MapQuestDirectionsService {

    constructor(private directionsService: MapquestService) {

    }

    calculateDirections(trip: Trip, options: DirectionOptions): Promise<any> {

        return new Promise(async (resolve, reject) => {

            var startLocation = new LatLng(trip.source.destinations[0].lat, trip.source.destinations[0].lng);
            var endLocation = new LatLng(trip.destination.destinations[0].lat, trip.destination.destinations[0].lng);

            var request = null;


            if (options == null) {
              request = {

                    locations: [
                        startLocation
                    ]
                }
            } else {
                request = {

                    locations: [
                        startLocation
                    ],
                    options: {
                        "avoids": [options.avoidTolls ? "Toll Road" : ""]
                    }
                }
            }


            this.populateLocations(request.locations, trip);
            request.locations.push(endLocation);
            console.log(request);

            this.directionsService.getRoute(request).then((res: any) => {
                trip.time = this.timeToSeconds(res.route.formattedTime);
                trip.distance = res.route.distance;
                trip.fuel = res.route.fuelUsed;
                trip.directions = this.toGoogleFormatDirectionsFormat(res);
                resolve(res);
            }).catch(e => {
                alert("Map Quest Quota May Have Been Exceeded, Please change the key in settings");
                window.location.reload();
            })
        })
    }


    private toGoogleFormatDirectionsFormat(res:any){
        
        var googleFormat = {
            geocoded_waypoints:[],
            routes:[{
                legs:[],
                waypoint_order:[]
            }],
            status:"OK",
            request:{}
        };


        var waypoints = 0;
        
        res.route.legs.forEach(l =>{

            googleFormat.routes[0].legs.push({
                distance:{
                    text:"",
                    value:l.distance
                },
                duration:{
                    text:"",
                    value:l.time
                },
                end_address:"",
                end_location:{
                    lat:-1,
                    lng:-1
                },
                start_address:"",
                start_location: {
                    lat:-1,
                    lng:-1
                }
            });

            googleFormat.routes[0].waypoint_order.push(waypoints);
            waypoints++;
        });

        googleFormat.routes[0].waypoint_order.splice(googleFormat.routes[0].waypoint_order.length-1,1);
        return googleFormat;
    }
    
    timeToSeconds(formattedTime: string): number {

        var segments = formattedTime.split(":");
        var hours = parseInt(segments[0])
        var mins = parseInt(segments[1]);
        var secs = parseInt(segments[2]);

        var hrsSecs = (hours * 60) * 60;
        var minSecs = (mins * 60);
        var totalSecs = hrsSecs + minSecs + secs;

        return totalSecs;
    }

    private populateLocations(locations: Array<any>, trip: Trip) {


        trip.areas.forEach(area => {
            locations.push(new LatLng(area.destinations[0].lat, area.destinations[0].lng));
        })

    }

    public calculateRoundTripDuration(response) {

        var legs: Array<any> = response.routes[0].legs;
        var totalTimeSeconds = 0;
        legs.forEach(leg => {

            totalTimeSeconds += leg.duration.value;
        });

        return totalTimeSeconds;
    }


    public getAdjustedTime(time: number) {

        var mins = time / 60;
        if (mins > 15) {
            return time + (60 * 12);
        } else {
            return time;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/utilities/MapQuest/DirectionsServiceMapQuest.ts